'use client';

import { Box, VStack } from '@terra/ui-styled-system';
import { HttpExchangeRows } from '../../components/tools/shared/http-exchange-rows';
import { MetaDefault } from '../../../../components/typography';
import type { BrowserNetworkRequest } from '../utils/browser-tool-output';

type BrowserNetworkProps = {
  url?: string;
  requests: BrowserNetworkRequest[];
};

export function BrowserNetwork({ url, requests }: BrowserNetworkProps) {
  return (
    <VStack alignItems="stretch" gap={2} width="100%">
      {url ? <MetaDefault color="fg.muted">{url}</MetaDefault> : null}
      <Box maxH="360px" overflow="auto" width="100%">
        <HttpExchangeRows
          entries={requests.map((request) => ({
            id: request.id,
            method: request.method,
            url: request.url,
            ...(request.status
              ? { responseStatus: String(request.status) }
              : {}),
          }))}
        />
      </Box>
    </VStack>
  );
}
